// extracted by mini-css-extract-plugin
export var menuIcon = "_oi-0";
export var menuIconInline = "_oi-1";